import { makeApi } from "../services/api";

//* INTERMEDIADOR ENTRE PREVIMUNE E SULTS - FORMULARIO INTERESSADO *//

async function SendToMake(data) {
  try {
    const response = await makeApi.post("/", data, {
      headers: { "Content-Type": "application/json" },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error(
        'Retorno não esperado:',
        response.status,
        response.statusText
      );
      return response;
    }
  } catch (error) {
    console.error('Erro ao enviar dados para o Make', error);
    return null;
  }
}

export default SendToMake;
